// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { routes } from 'src/routes';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
// import { isDevStore } from 'src/helpers/language-setting';
import MainMenuItem from './item';

import { enableThemeSetupV3 } from 'src/helpers/theme-setup-helper';
import { allowToShowBFCM23 } from 'src/helpers/dashboard-helper';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';
import { allowUsingNewSearchSettings } from 'src/helpers/search-settings-helper';
import { TEST_MOVING_PRODUCT_DATA_SOURCE_STORES } from 'src/constants/recommendation';
import { checkUserEnableShowAppVersionSwitching } from 'src/helpers/account-helper';
import { enableShopifyIntegration } from 'src/helpers/theme-setup-helper';

type Props = {
  renderPopover: () => void
};

type ComposedProps = Props & WithI18nProps;

class MainMenu extends Component<ComposedProps> {
  render() {
    const {
      menuId = '',
      menuIdMetaMatchOldNav,
      themeSetupV2 = false,
      merchandisingV2 = false,
      defaultThemeSettings,
      recommendation,
      tenantId,
      i18n,
      tenantApp,
      isNewSearch
    } = this.props;
    const isCheckEnableThemeSetupV3 = enableThemeSetupV3(tenantApp);
    const hasShopifyIntegration = enableShopifyIntegration(tenantApp);
    const enableAppVersionSwitching = checkUserEnableShowAppVersionSwitching(tenantApp);

    let mainMenu = [
      {
        title: i18n.translate('AdminHTML.MainMenu.home'),
        id: 'menu-home',
        routeTo: routes.dashboard.view(),
        isNew: false
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.sync'),
        id: 'menu-settings-sync-overview',
        routeTo: routes.sync.view(),
        isNew: false
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.analytics'),
        id: 'menu-analytics',
        isNew: false,
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenu.appImpact'),
            isNew: false,
            id: 'menu-analytics-performance-revenue',
            routeTo: routes.analytics.appImpact()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.searchAnalytics'),
            isNew: false,
            id: 'menu-analytics-search',
            routeTo: routes.analytics.overviewSearch()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.collectionAnalytics'),
            isNew: false,
            id: 'menu-analytics-collection',
            routeTo: routes.analytics.overviewCollection()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.recommendationAnalytics'),
            isNew: false,
            id: 'menu-analytics-recommendation',
            routeTo: routes.analytics.recommendationOverview()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.analyticSettings'),
            isNew: false,
            id: 'menu-analytics-settings',
            routeTo: routes.analytics.settings()
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.filter'),
        id: 'menu-filter',
        isNew: false,
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenu.manageFilterTrees'),
            isNew: false,
            id: 'menu-filters-filter-trees',
            routeTo: routes.filterTree.list()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.filterLayout'),
            isNew: false,
            id: 'menu-filters-layout',
            routeTo: routes.filterLayout.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.filterSettings'),
            isNew: false,
            id: 'menu-filters-display-settings',
            routeTo: routes.filterSettings.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.mergeValues'),
            isNew: false,
            id: 'menu-filters-merge-values',
            routeTo: routes.mergeValues.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.customRangeSliders'),
            isNew: false,
            id: 'menu-filters-custom-range-sliders',
            routeTo: routes.customRangeSlider.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.swatchSettings'),
            isNew: false,
            id: 'menu-filters-swatch-settings',
            routeTo: routes.swatchSettings.view()
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.search'),
        id: 'menu-search',
        isNew: false,
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenu.searchControl'),
            isNew: false,
            id: 'menu-search-search-control',
            routeTo: routes.searchControl.view(),
            isHide: !isNewSearch
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.standardSearch'),
            isNew: false,
            id: 'menu-search-standard-search',
            routeTo: routes.relevanceSettings.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.advancedSearch'),
            badge: {
              content: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={getAssetURL(ADMIN_APP_ASSET_PATHS?.standardSearch?.wand)}
                    alt="wand"
                    style={{ marginRight: '4px' }}
                  />
                  <span>{i18n.translate('AdminHTML.AdvanceSearch.iconText')}</span>
                </div>
              ),
              status: 'warning'
            },
            isNew: false,
            id: 'menu-search-advanced-search',
            routeTo: routes.aiSynonym.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.testYourSearch'),
            isNew: false,
            badge: {
              content: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {i18n.translate('AdminHTML.Common.Badge.new')}
                </div>
              ),
              status: 'info'
            },
            isHide: !isNewSearch,
            id: 'menu-search-test-your-search',
            routeTo: routes.testYourSearch.view()
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.merchandising'),
        id: 'menu-merchandising',
        isNew: false,
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenu.productRanking'),
            isNew: false,
            id: 'menu-merchandising-product-ranking',
            routeTo: routes.productRanking.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.ruleBasedMerchandising'),
            isNew: false,
            id: 'menu-merchandising-merchandising',
            routeTo: routes.merchandising.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.productVisibility'),
            isNew: false,
            id: 'menu-merchandising-product-visibility',
            routeTo: routes.productVisibility.view()
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.recommendation'),
        id: 'menu-recommendation',
        isNew: false,
        // badge: { content: i18n.translate('AdminHTML.MainMenu.new'), status: 'info' },
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenu.recommendationManageWidgets'),
            isNew: false,
            id: 'menu-recommendation-widget',
            routeTo: routes.recommendationWidgets.list()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.manualRecommendation'),
            isNew: false,
            id: 'menu-recommendation-manual-recommendation',
            routeTo: routes.manualRecommendation.list()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.recommendationGeneralSettings'),
            isNew: false,
            id: 'menu-recommendation-general-settings',
            routeTo: routes.recommendationGeneralSettings.settings()
          }
          // {
          //   title: i18n.translate('AdminHTML.MainMenu.recommendationDefaultDesign'),
          //   isNew: false,
          //   id: 'menu-recommendation-default-design-settings',
          //   routeTo: routes.recommendationDefaultDesignSettings.view()
          // }
        ]
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.personalization'),
        id: 'menu-personalization',
        routeTo: routes.personalization.view(),
        isNew: false
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.theme'),
        id: 'menu-theme',
        isNew: false,
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenu.themeSetup'),
            isNew: false,
            id: 'menu-integration-theme-setup',
            routeTo: routes.themeSetup.view()
          },
          // {
          //   title: i18n.translate('AdminHTML.MainMenu.switchFilterLayout'),
          //   isNew: false,
          //   id: 'menu-theme-switch-layout',
          //   routeTo: routes.switchLayout.view()
          // },
          {
            title: i18n.translate('AdminHTML.MainMenu.quickViewCartSettings'),
            isNew: false,
            id: 'menu-theme-quick-view-cart-settings',
            routeTo: routes.quickViewCartSettings.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.defaultLayoutSettings'),
            isNew: false,
            id: 'menu-theme-default-layout-settings',
            routeTo: routes.defaultLayoutSettings.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.defaultThemeSettings'),
            isNew: false,
            id: 'menu-theme-default-theme-settings',
            routeTo: routes.defaultThemeSettings.view()
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.MainMenu.tool'),
        id: 'menu-general-settings',
        isNew: false,
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenu.translation'),
            isNew: false,
            id: 'menu-settings-translation',
            routeTo: routes.translation.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.integration'),
            isNew: false,
            id: 'menu-integration-third-party',
            routeTo:
              enableAppVersionSwitching && hasShopifyIntegration
                ? routes.integration.thirdParty.view()
                : routes.integration.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.metafields'),
            isNew: false,
            id: 'menu-settings-metafields',
            routeTo: routes.metafield.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.customSorting'),
            isNew: false,
            id: 'menu-settings-sorting',
            routeTo: routes.customSorting.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.variantsDisplay'),
            isNew: false,
            id: 'menu-settings-variants-display',
            routeTo: routes.variantsDisplay.view()
          },
          {
            title: i18n.translate('AdminHTML.MainMenu.subscription'),
            isNew: false,
            id: 'menu-account-subscription',
            routeTo: routes.subscription.plan()
          },
          {
            title: i18n.translate('AdminHTML.MainMenuV2.appPreferences'),
            isNew: false,
            id: 'menu-account-app-preferences',
            routeTo: routes.appPreferences.view()
          }
        ]
      }
    ];

    // Show language setting for dev store
    // if (!isDevStore(tenantId)) {
    //   let tool = _.find(mainMenu, item => item.id === 'menu-tool');
    //   let toolSubMenu = tool.subMenu;
    //   _.remove(toolSubMenu, item => item.id === 'menu-tool-language-setting');
    // }

    let tool = _.find(mainMenu, item => item.id === 'menu-general-settings');
    let toolSubMenu = tool.subMenu;
    const bfcm23 = allowToShowBFCM23(tenantApp);
    if (bfcm23.allow && bfcm23.type !== 'professional365') {
      const tool = _.find(mainMenu, item => item.id === 'menu-general-settings');
      const subscriptionMenu = _.find(
        tool.subMenu,
        item => item.id === 'menu-account-subscription'
      );
      subscriptionMenu.badge = {
        content: (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={getAssetURL(ADMIN_APP_ASSET_PATHS?.common?.stars)}
              alt="stars"
              style={{ marginRight: '4px' }}
            />
            <span>
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.BFCM2023_Discount_Percent')}
            </span>
          </div>
        ),
        status: 'warning'
      };
    }

    if (merchandisingV2) {
      const merchandisingMenu = _.find(mainMenu, item => item.id === 'menu-merchandising');
      // update route for merchandising v2
      merchandisingMenu.routeTo = routes.merchandising.view();
      merchandisingMenu.isNew = false;
      merchandisingMenu.title = i18n.translate('AdminHTML.MainMenu.merchandising_v2');

      // remove submenu of merchandising v1
      _.unset(merchandisingMenu, 'subMenu');
    }

    if (!themeSetupV2) {
      _.remove(toolSubMenu, item => item.id === 'menu-settings-sorting');
      // Remove variant display

      let filter = _.find(mainMenu, item => item.id === 'menu-filter');
      filter.isNew = false;
      let filterSubMenu = filter.subMenu;
      _.remove(filterSubMenu, item => item.id === 'menu-filters-layout');
      _.remove(filterSubMenu, item => item.id === 'menu-filters-swatch-settings');

      let theme = _.find(mainMenu, item => item.id === 'menu-theme');
      let themeSubMenu = theme.subMenu;
      _.remove(themeSubMenu, item => item.id === 'menu-theme-quick-view-cart-settings');
    } else {
      let theme = _.find(mainMenu, item => item.id === 'menu-theme');
      let themeSubMenu = theme.subMenu;
      _.remove(themeSubMenu, item => item.id === 'menu-theme-default-layout-settings');
      // Not force using Variants Display and total products > 5000 => Hide
    }

    if (!defaultThemeSettings) {
      let theme = _.find(mainMenu, item => item.id === 'menu-theme');
      let themeSubMenu = theme.subMenu;
      _.remove(themeSubMenu, item => item.id === 'menu-theme-default-theme-settings');
    }

    mainMenu.forEach(menu => {
      const { subMenu, isNew } = menu;
      if (_.isEmpty(subMenu) || isNew) return;
      menu.isNew = _.some(subMenu, item => item.isNew === true);
      if (menu.isNew) {
        menu.badge = { content: i18n.translate('AdminHTML.MainMenu.new'), status: 'info' };
      }
    });

    const activeRecommendation = _.get(recommendation, 'status', 'inactive');
    const enableRecommendation = _.get(recommendation, 'settings.enable', false);
    if (activeRecommendation !== 'active' || !enableRecommendation) {
      _.remove(mainMenu, item => item.id === 'menu-recommendation');
    } else if (!TEST_MOVING_PRODUCT_DATA_SOURCE_STORES.includes(tenantId)) {
      let recommendation = _.find(mainMenu, item => item.id === 'menu-recommendation');
      let recommendationSubMenu = recommendation.subMenu;
      _.remove(
        recommendationSubMenu,
        item => item.id === 'menu-recommendation-manual-recommendation'
      );
    }

    if (isCheckEnableThemeSetupV3) {
      let theme = _.find(mainMenu, item => item.id === 'menu-theme');
      let themeSubMenu = theme.subMenu;
      _.remove(themeSubMenu, item => {
        return (
          item.id === 'menu-theme-quick-view-cart-settings' ||
          item.id === 'menu-theme-default-layout-settings' ||
          item.id === 'menu-theme-default-theme-settings'
        );
      });
      if (themeSubMenu.length === 1 && themeSubMenu[0].id === 'menu-integration-theme-setup') {
        delete theme.subMenu;
        theme.routeTo = routes.themeSetup.view();
      }
    }

    return (
      <React.Fragment>
        <div className="BC_MainMenu_Wrapper">
          <ul
            className={`BC_MainMenu menu-${mainMenu.length} ${
              bfcm23.allow && bfcm23.type !== 'professional365' && 'BFCM23'
            }`}>
            {mainMenu.map((menuItemData, index) => (
              <MainMenuItem
                key={index}
                menuId={menuId}
                menuIdMetaMatchOldNav={menuIdMetaMatchOldNav}
                data={menuItemData}
              />
            ))}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const currentTotalProducts = _.get(tenantApp, 'appParams.currentTotalProducts', 0);
  const recommendation = _.get(tenantApp, 'settings.recommendation', {});
  const themeSetupV2 = _.get(tenantApp, 'adminAppFeatures.themeSetupV2', false);
  const searchVersion = _.get(state.oauth, 'tenantApp.parseParams.searchVersion', '1.0');
  const isNewSearch = allowUsingNewSearchSettings(searchVersion);

  return {
    tenantApp,
    themeSetupV2: themeSetupV2,
    variantsDisplay: _.get(tenantApp, 'adminAppFeatures.variantsDisplay', false),
    defaultThemeSettings: _.get(tenantApp, 'adminAppFeatures.defaultThemeSettings', false),
    merchandisingV2: _.get(tenantApp, 'settings.visualMerchandising.settings.enable', false),
    currentTotalProducts,
    recommendation,
    settings: _.get(tenantApp, 'settings', {}),
    enableAISearch: _.get(tenantApp, 'settings.instantSearch.settings.AI-synonyms', false),
    isNewSearch,
    tenantId: _.get(tenantApp, 'tenantId', '')
  };
};

export default connect(mapStateToProps)(withI18n()(MainMenu));
